import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import jQuery from 'jquery'
import '../styles/theme/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import googlePhone from 'google-libphonenumber'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import 'moment-timezone'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import * as Sentry from "@sentry/vue"
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import VueHighlightJS from 'vue-highlightjs'
import loadStock from 'highcharts/modules/stock'
import loadExporting from 'highcharts/modules/exporting'
import loadOfflineExporting from 'highcharts/modules/offline-exporting'
import loadSunburst from 'highcharts/modules/sunburst'
import loadMap from 'highcharts/modules/map'
import loadDrilldown from 'highcharts/modules/drilldown'
import HighchartsThemes from './HighchartsTheme'
import VueMq from 'vue-mq'
import VueVisible from 'vue-visible'
import Echo from 'laravel-echo'
import ct from "countries-and-timezones"

// Require `PhoneNumberFormat`.
window.PNF = googlePhone.PhoneNumberFormat

window.timezone = 'Intl' in window ? new Intl.DateTimeFormat().resolvedOptions().timeZone : 'America/Los_Angeles'
window.countriesAndTimezones = ct

loadStock(Highcharts)
loadExporting(Highcharts)
loadOfflineExporting(Highcharts)
loadSunburst(Highcharts)
loadMap(Highcharts)
loadDrilldown(Highcharts)
Highcharts.theme = HighchartsThemes.themes.future

Highcharts.setOptions(Highcharts.theme)
Highcharts.setOptions({
    chart: {
        events: {
            load: function () {
                let chart = this

                setTimeout(() => {
                    if (chart && chart.series) {
                        $.each(chart.series, function (i, series) {
                            $.each(series.data, function (j, data) {
                                if (data && data.yBottom && data.plotY && data.dataLabel) {
                                    if (data.yBottom - data.plotY < 15) {
                                        data.dataLabel = data.dataLabel.destroy()
                                    }
                                }
                            })
                        })
                    }
                }, 100)
            }
        },
        style: {
            fontFamily: ["Quicksand", "-apple-system", "system-ui", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "sans-serif"]
        }
    }
})

// Get an instance of `PhoneNumberUtil`.
window.phoneUtil = googlePhone.PhoneNumberUtil.getInstance()

window.getLocaleIfPhoneNumberIsFromNorthAmerica = function (phoneNumber) {
    if (!phoneNumber) {
        return false
    }

    let valid_countries = ['CA', 'US', 'AG', 'AI', 'AS', 'BB', 'BM', 'BS', 'DM', 'DO', 'GD', 'GU', 'JM', 'KN', 'KY', 'LC', 'MP', 'MS', 'PR', 'SX', 'TC', 'TT', 'VC', 'VG', 'VI', 'UM']

    try {
        for (let valid_country of valid_countries) {
            let number = window.phoneUtil.parseAndKeepRawInput(phoneNumber, valid_country)
            let isPossible = window.phoneUtil.isPossibleNumber(number)
            if (isPossible) {
                if (window.phoneUtil.isValidNumberForRegion(number, valid_country)) {
                    return valid_country
                }
            }
        }
        // Fallback: accept numbers that are "possible" for US/CA even when strict
        // region validation fails — new area codes (e.g. 472, introduced Oct 2022)
        // can lag behind the library's metadata.
        for (let valid_country of ['US', 'CA']) {
            let number = window.phoneUtil.parseAndKeepRawInput(phoneNumber, valid_country)
            if (window.phoneUtil.isPossibleNumber(number)) {
                return valid_country
            }
        }

        return false
    } catch (err) {
        return false
    }
}

window.getLocaleIfPhoneNumberIsFromGreatBritainOrAustralia = function (phoneNumber) {
    if (!phoneNumber) {
        return false
    }

    let valid_countries = ['GB', 'AU', 'IE']

    try {
        for (let valid_country of valid_countries) {
            let number = window.phoneUtil.parseAndKeepRawInput(phoneNumber, valid_country)
            let isPossible = window.phoneUtil.isPossibleNumber(number)
            if (isPossible) {
                if (window.phoneUtil.isValidNumberForRegion(number, valid_country)) {
                    return valid_country
                }
            }
        }
        return false
    } catch (err) {
        return false
    }
}

window.guessLocale = function (phoneNumber) {
    if (!phoneNumber) {
        return false
    }

    try {
        // handle US and CA as an special case
        let north_america_locale = window.getLocaleIfPhoneNumberIsFromNorthAmerica(phoneNumber)
        if (north_america_locale) {
            return north_america_locale
        }

        // will add + to phone number and check again
        if (!phoneNumber.includes('+')) {
            north_america_locale = window.getLocaleIfPhoneNumberIsFromNorthAmerica('+' + phoneNumber)
            if (north_america_locale) {
                return north_america_locale
            }
        }

        // will add +1 to phone number and check again
        if (!phoneNumber.includes('+')) {
            north_america_locale = window.getLocaleIfPhoneNumberIsFromNorthAmerica('+1' + phoneNumber)
            if (north_america_locale) {
                return north_america_locale
            }
        }

        // handle GB & AU as a special case
        let english_locale = window.getLocaleIfPhoneNumberIsFromGreatBritainOrAustralia(phoneNumber)
        if (english_locale) {
            return english_locale
        }

        // if we reached here then it's definitely not a US or CA number according to google-libphonenumber
        // let's check for international locales

        let number = window.phoneUtil.parse(phoneNumber)
        let locale = window.phoneUtil.getRegionCodeForNumber(number)

        if (!locale) {
            return false
        }

        return locale
    } catch (err) {
        return false
    }
}

window.Highcharts = Highcharts

Vue.use(VueRouter)
Vue.use(VueVisible)
Vue.use(VueHighlightJS)
Vue.use(ElementUI, {locale})
Vue.use(VueHighcharts, {Highcharts})
Vue.use(wysiwyg, {
    hideModules: {
        image: true,
        table: true,
        removeFormat: true,
    }
})
Vue.use(VueMq, {
    breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xxl: Infinity
    }
})

window.Vue = Vue

window.VueEvent = new class {
    constructor() {
        this.vue = new Vue()
    }

    fire(event, data = null) {
        this.vue.$emit(event, data)
    }

    unlisten(event, callback) {
        this.vue.$off(event, callback)
    }

    listen(event, callback) {
        this.vue.$on(event, callback)
    }
}

window._ = require('lodash')

try {
    window.$ = window.jQuery = jQuery
} catch (e) {
}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.axios.defaults.headers.common['Requested-From'] = 'admin-api'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')
let admin_api_token = localStorage.getItem("admin_api_token")

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

if (admin_api_token) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('admin_api_token')
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
window.Pusher = require('pusher-js')

window.Echo = new Echo({
    broadcaster: 'pusher',
    // Get websocket configuration from local storage
    key: localStorage.getItem('ws_app_key'),
    cluster: localStorage.getItem('ws_cluster'),
    // Websocket hosts are the same for both ws and wss
    wsHost: localStorage.getItem('ws_host'),
    wssHost: localStorage.getItem('ws_host'),
    forceTLS: true,
    auth: {
        headers: {
            Authorization: 'Bearer ' + admin_api_token,
            'Requested-From': 'admin-api',
            'driver': 'pusher',
        },
    },
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
})


String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

window.paceOptions = {
    restartOnRequestAfter: false,
    ajax: {
        trackWebSockets: false
    }
}

window.timezone = 'Intl' in window ? new Intl.DateTimeFormat().resolvedOptions().timeZone : 'America/Los_Angeles'
momentDurationFormatSetup(moment)
window.moment = moment

function getDomainName(hostName) {
    return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1)
}

window.Sentry = Sentry

if (['production', 'development'].includes(process.env.NODE_ENV) && localStorage.getItem('app_env') != 'local') {
    Sentry.init({
        Vue,
        dsn: localStorage.getItem('sentry_dsn_public'),
        tracingOptions: {
            trackComponents: true,
        },
        attachProps: true,
        trackComponents: true,
        tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE,
        ignoreErrors: [
            'Non-Error promise rejection captured with value: undefined',
            'Cannot read property \'is_reseller\' of null',
            'No error message',
            '$ is not defined',
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
            'Cannot read property \'offsetHeight\' of undefined',
            'Request failed with status code 504',
            'Request failed with status code 500',
            'Action timed out',
            'Network Error',
            'Expired token',
            'Network request failed',
            'Failed to fetch',
            'NetworkError',
            'Navigation cancelled from',
            'Blocked a frame with origin'
        ],

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,

        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        integrations: [
            Sentry.browserTracingIntegration(),
        ],
    })

    Sentry.setTag('environment', process.env.NODE_ENV)
}

// Branding :D
console.log(`%c
 █████╗ ██╗      ██████╗ ██╗    ██╗ █████╗ ██████╗ ███████╗
██╔══██╗██║     ██╔═══██╗██║    ██║██╔══██╗██╔══██╗██╔════╝
███████║██║     ██║   ██║██║ █╗ ██║███████║██████╔╝█████╗
██╔══██║██║     ██║   ██║██║███╗██║██╔══██║██╔══██╗██╔══╝
██║  ██║███████╗╚██████╔╝╚███╔███╔╝██║  ██║██║  ██║███████╗
╚═╝  ╚═╝╚══════╝ ╚═════╝  ╚══╝╚══╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝
`, 'color: #FF0000')
